import { ON_LOGOUT } from 'app/actions/authActions';
import { API, graphqlOperation } from 'aws-amplify';
import { getLikiee } from 'graphql/likiees/queries';
import { createReducer, getError } from 'utils/appHelpers';
import { createLikieeMutation, deleteLikieeMutation } from 'graphql/likiees/mutations';
import store from 'redux/store';
import { onCreateLikiee, onDeleteLikiee, onUpdateLikiee } from 'graphql/likiees/subscriptions';
import { onSubscribe } from 'shared/utils/graphHelpers';
import { onRemoveProjectItemsItem } from './projectItems';

const productsInitialData = {};
let productCreateSubs, productUpdateSubs, productDeleteSubs;

const ON_PRODUCTS_GET = '@@home/ON_PRODUCTS_GET';
const ON_ADD_PRODUCT = '@@home/ON_ADD_PRODUCT';
const ON_UPDATE_PRODUCT = '@@home/ON_UPDATE_PRODUCT';
const ON_REMOVE_PRODUCT = '@@home/ON_REMOVE_PRODUCT';

const productsHandlers = {
  [ON_PRODUCTS_GET]: (state, action) => ({ ...state, ...action.payload }),
  [ON_ADD_PRODUCT]: (state, action) => {
    if (!action.payload || !action.payload.id) {
      console.warn('ON_ADD_PRODUCT: Invalid payload received', action.payload);
      return state;
    }
    return { ...state, [action.payload.id]: action.payload };
  },
  [ON_UPDATE_PRODUCT]: (state, action) => {
    if (!action.payload || !action.payload.id) {
      console.warn('ON_UPDATE_PRODUCT: Invalid payload received', action.payload);
      return state;
    }
    const newState = { ...state };
    newState[action.payload.id] = { ...newState[action.payload.id], ...action.payload };
    return { ...newState };
  },
  [ON_REMOVE_PRODUCT]: (state, action) => {
    if (!action.payload || !action.payload.id) {
      console.warn('ON_REMOVE_PRODUCT: Invalid payload received', action.payload);
      return state;
    }
    const newState = { ...state };
    delete newState[action.payload.id];
    return { ...newState };
  },
  [ON_LOGOUT]: () => {
    productCreateSubs?.unsubscribe();
    productUpdateSubs?.unsubscribe();
    productDeleteSubs?.unsubscribe();
    return {};
  },
};

export const onSetProducts = payload => ({ type: ON_PRODUCTS_GET, payload });
export const onAddProduct = payload => ({ type: ON_ADD_PRODUCT, payload });
export const onUpdateProduct = payload => ({ type: ON_UPDATE_PRODUCT, payload });
export const onRemoveProduct = payload => ({ type: ON_REMOVE_PRODUCT, payload });

export const productsReducer = createReducer(productsInitialData, productsHandlers);

export const subscribeToProductChanges = async ({ onAddProduct, onUpdateProduct, onDeleteProduct }) => {
  productCreateSubs = await onSubscribe(onCreateLikiee, 'onCreateLikiee', product => {
    onAddProduct && onAddProduct(product);
  });
  productUpdateSubs = await onSubscribe(onUpdateLikiee, 'onUpdateLikiee', product => {
    onUpdateProduct && onUpdateProduct(product);
  });
  productDeleteSubs = await onSubscribe(onDeleteLikiee, 'onDeleteLikiee', product => {
    onDeleteProduct && onDeleteProduct(product);
  });
};

export const unSubscribeProductChanges = () => {
  productCreateSubs?.unsubscribe();
  productUpdateSubs?.unsubscribe();
  productDeleteSubs?.unsubscribe();
};

export const getAndUpdateProduct = async (id, updateData = {}) => {
  try {
    const { data } = await API.graphql(graphqlOperation(getLikiee, { id }));
    store.dispatch(onUpdateProduct({ ...data.getLikiee, ...updateData }));
  } catch (err) {
    throw new Error(getError(err));
  }
};

export const createProduct = async body => {
  const { data } = await API.graphql(graphqlOperation(createLikieeMutation, { input: body }));
  const products = store.getState().products;
  data.createLikiee.order = Object.keys(products).length + 1;
  await store.dispatch(onAddProduct(data.createLikiee));
  return data.createLikiee;
};

export const deleteProduct = async id => {
  const input = { id };
  const { data } = await API.graphql(graphqlOperation(deleteLikieeMutation, { input }));
  // Fake await 1 second, that backend has time to delete the product with scheduller
  await new Promise(resolve => setTimeout(resolve, 1000));
  await store.dispatch(onRemoveProduct(data.deleteLikiee.id));
  store.dispatch(onRemoveProjectItemsItem(data.deleteLikiee.id));
};
